import { useState } from 'react';

import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import {
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_SORT_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_SORT_OPTION_MODEL,
} from './models';
import {
  useAccountUserDetailLikeBrandListQuery,
  useAccountUserDetailLikeBrandLogListQuery,
  useAccountUserLikeBrandDetailQuery,
} from './query';
import { getTablePages } from '../../../../../lib/utils/tableUtils';

export const useAccountUserLikeBrandDetail = ({ userId, isActive }) => {
  const { data } = useAccountUserLikeBrandDetailQuery({
    userId,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_LIKE_BRAND_DETAIL_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => result.data.likeBrandSummaryData,
    },
  });

  return data;
};

export const useAccountUserDetailLikeBrandList = ({ userId, isActive }) => {
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_FILER_OPTION_MODEL);
  const [sortOption, setSortOption] = useState(ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_SORT_OPTION_MODEL);

  const { data } = useAccountUserDetailLikeBrandListQuery({
    userId,
    filterOption,
    sortOption,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_LIKE_BRAND_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => {
        return {
          list: result.data.likeBrandHistoryList.list,
          totalCnt: result.data.likeBrandHistoryList.totalCnt,
        };
      },
    },
  });

  const getList = ({ sortOption, filterOption }) => {
    sortOption && setSortOption(sortOption);
    filterOption && setFilterOption(filterOption);
  };

  return { likeBrandHistory: data, filterOption, sortOption, getList };
};

export const useAccountUserDetailLikeBrandLogList = ({ userId, actionLogType, setActionLogType }) => {
  const [pagination, setPagination] = useState(LIST_PAGINATION_MODEL);
  const [filterOption, setFilterOption] = useState(ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_FILER_OPTION_MODEL);
  const [sortOption, setSortOption] = useState(ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_SORT_OPTION_MODEL);

  const { data } = useAccountUserDetailLikeBrandLogListQuery({
    userId,
    pagination,
    filterOption,
    sortOption,
    actionLogType,
    options: {
      enabled: !!userId,
      keepPreviousData: true,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_LIKE_BRAND_LOG_LIST_REQUEST_SUCCESS),
      onError: (error) => {
        toastMsg.error(error.message);
      },
      select: (result) => ({
        logList: result.data.likeBrandLogList,
        totalCnt: result.data.totalCnt,
      }),
    },
  });

  const getList = ({ pagination, sortOption, filterOption }) => {
    pagination && setPagination(pagination);
    sortOption && setSortOption(sortOption);

    if (filterOption) {
      setActionLogType(filterOption.actionLogType);
      setFilterOption(filterOption);
    }
  };

  return {
    likeBrandLogList: data,
    filterOption: { ...filterOption, actionLogType },
    sortOption,
    pagination: { ...pagination, pages: getTablePages(data.totalCnt, pagination.pageSize) },
    getList,
  };
};
